export const chatCss = {
    position: "absolute",
    left: "16%",
    top: "25%",
    width: "7%",
}

export const ChatLogo = ({ color }) => {
	const common = {
		stroke: color,
		strokeMiterLimit: 10,
	};
	const style1 = {
		...common,
		fill: color,
		strokeWidth: "2px",
	};
	const style2 = {
		...common,
		fill: "#fff",
		strokeWidth: "8px",
	};
	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 232.58 247.6"
		>
			<path
				style={style1}
				d="M218.57,4H14.01c-5.53,0-10.01,4.48-10.01,10.01V199.75c0,5.53,4.48,10.01,10.01,10.01H153.43l32.79,32.79c2.25,2.25,6.1,.66,6.1-2.53v-30.26h26.25c5.53,0,10.01-4.48,10.01-10.01V14.01c0-5.53-4.48-10.01-10.01-10.01Z"
			/>
			<path
				style={style2}
				d="M96.95,84.41h96.93c6.7,0,12.13,5.43,12.13,12.13v55.3c0,6.7-5.43,12.13-12.13,12.13h-4.26v22.13c0,.76-.92,1.14-1.45,.6l-22.74-22.74H96.95c-6.7,0-12.13-5.43-12.13-12.13v-55.3c0-6.7,5.43-12.13,12.13-12.13Z"
			/>
			<path
				style={style2}
				d="M136.02,25.45H39.09c-6.7,0-12.13,5.43-12.13,12.13v55.3c0,6.7,5.43,12.13,12.13,12.13h4.26v22.13c0,.76,.92,1.14,1.45,.6l22.74-22.74h68.48c6.7,0,12.13-5.43,12.13-12.13V37.58c0-6.7-5.43-12.13-12.13-12.13Z"
			/>
			<rect
				style={style1}
				x="53.08"
				y="64.23"
				width="68.95"
				height="6.65"
				rx="3.33"
				ry="3.33"
			/>
			<rect
				style={style1}
				x="44.97"
				y="43.07"
				width="85.15"
				height="6.65"
				rx="3.33"
				ry="3.33"
			/>
		</svg>
	);
};
